const ATS_VERSION = "1.2.1-development.761d7d9+build.20210506111629";
// eslint-disable-next-line import/prefer-default-export
export { ATS_VERSION };
//# sourceMappingURL=version.js.map